/**
 * 编辑回看视频信息
 * Create by liaokai on 2020-06-19 16:08:17
 */
import * as React from 'react';
import {Component} from "react";
import {Input, message, Modal} from "antd";
import {TitleContentTable} from "../../../../../meeting-list/meeting/menu/lecturer/preview/title-content-table/title-content-table";
import {IliveRecordIndexItem} from "../../../../../../../common/apis/apis/live/liveRecordIndex";
import {liveRecordUpdate} from "../../../../../../../common/apis/apis/live/liveRecordUpdate";

const defaultItem : IliveRecordIndexItem = {
    "id": 0,
    "title": "",
    "publish_status": "",
    "poster": "",
    "run_time": "",
    "expiration_time": "", //过期时间
    "status": "", //状态 1 代表回放
    "is_default": false, //是否默认
    tanscode_status:1,
    "create_time": "", // 创建时间
}

interface IProps{
    visible : boolean
    onCancel? : () => void
    onSubmit? : () => void
    editItem?: IliveRecordIndexItem
}

interface IState{
    editItem : IliveRecordIndexItem
}

export class LiveEditRecordVideo extends Component<IProps,IState>{
    readonly state : IState = {
        editItem : defaultItem
    };

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if(JSON.stringify(this.props.editItem) !== JSON.stringify(prevProps.editItem) ){
            this.setState({editItem : this.props.editItem ?? defaultItem})
        }
    }

    render() {
        let {onCancel,onSubmit,visible} = this.props;
        let {editItem} = this.state;
        return (
            <Modal
                visible={visible}
                onCancel={()=>{
                    onCancel?.();
                }}
                onOk={()=>{
                    liveRecordUpdate(editItem as any).then(()=>{
                        onSubmit?.()
                        onCancel?.()
                    }).catch(e => {
                        message.error("保存失败 " + e.data?.message)
                    })
                }}
                cancelText={"取消"}
                okText={"保存"}
                title={"编辑回放"}
            >
                <TitleContentTable colGap={10} rowGap={10}>
                    <div>标题</div>
                    <Input placeholder={"请输入标题"} value={editItem.title} onChange={e => {
                        editItem.title = e.target.value
                        this.setState({editItem : editItem})
                    }}/>
                </TitleContentTable>
            </Modal>
        );
    }
}
